import { useAppDispatch } from 'hooks';
import React, { useEffect } from 'react';
import { useChatContext } from '../hooks';

interface Props {
  appUserID: string | undefined;
  children: React.ReactNode;
}

export const ProviderChatAuthUser: React.FC<Props> = ({ children, appUserID }) => {
  const { socket } = useChatContext();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (appUserID) {
      socket.auth = { appUserID };
      socket.connect();
    }
  }, [appUserID, socket, dispatch]);

  return <>{children}</>;
};
